import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
interface LayoutPageProps {
    listStages: { number: number, text: string }[],
}
const LayoutPage: React.FC<LayoutPageProps> = ({ listStages }) => {
    return (
        <div className="aimed-layout-page">
            <FullWrapper caseName="aimed-layout-pageCase">
                <div className="aimed-layout-pageWrapper">
                    <div className="aimed-layout-pageListParagraf">
                        <div className="aimed-layout-pageParagraf">
                            Команда &laquo;Вебпрактик&raquo; не&nbsp;впервые сталкивается
                            с&nbsp;задачей создания технологической платформы для проведения
                            конкурса по&nbsp;определению лучших систем искусственного интеллекта.
                            Ранее мы&nbsp;делали проект{' '}
                            <a
                                className="aimed-layout-pageLink"
                                href="https://webpractik.ru/cases/development/upgreat/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                ПРО//ЧТЕНИЕ
                            </a>
                            .
                        </div>
                        <div className="aimed-layout-pageParagraf">
                            На&nbsp;этот раз нам нужно разработать платформу для проведения
                            испытаний в&nbsp;рамках конкурсов{' '}
                            <a
                                className="aimed-layout-pageLink"
                                href="https://aimfinder.upgreat.one/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                AI&rsquo;m Finder
                            </a>{' '}
                            и&nbsp;
                            <a
                                className="aimed-layout-pageLink"
                                href="https://ai4med.upgreat.one/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                AI&rsquo;m Doctor
                            </a>
                            . Конкурс и&nbsp;платформа&nbsp;&mdash; это еще один шаг для преодоления
                            глобального технологического барьера в&nbsp;области искусственного
                            интеллекта в&nbsp;медицине.
                        </div>
                    </div>
                    <div className="aimed-layout-pageBottom">Задача</div>
                    <div className="aimed-layout-pageOneParagraf">
                        Научить искусственный интеллект анализировать эпикризы пациентов, результаты
                        клинических исследований и&nbsp;сопоставлять эти данные с&nbsp;информацией
                        из&nbsp;медицинских баз и&nbsp;клинических рекомендаций. В&nbsp;результате
                        должна появится новая интеллектуальная система-помощник врачей для первичной
                        диагностики.
                    </div>
                    <div className="aimed-layout-pageSubtitle">Для этого нужно:</div>
                    {listStages.map((item, index) => (
                        <div key={index} className="aimed-layout-pageList">
                            <div className="aimed-layout-pageListNumber">{item.number}</div>
                            <div
                                dangerouslySetInnerHTML={{ __html: item.text }}
                                className="aimed-layout-pageListText"
                            />
                        </div>
                    ))}

                    <div className="aimed-layout-pageBlock">
                        Участники конкурсов должны разработать свои ИИ-системы и&nbsp;научить
                        их&nbsp;анализировать эпикризы, выделять и&nbsp;классифицировать симптомы
                        заболеваний по&nbsp;шести лёгочным нозологиям и&nbsp;формулировать
                        заключительный клинический диагноз. И&nbsp;делать это автоматически,
                        за&nbsp;счет интеллектуальной обработки протоколов медосмотров. Финальные
                        соревнования состоятся в&nbsp;ноябре 2024&nbsp;г. Победитель конкурса
                        получит приз 200 млн руб.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default LayoutPage;
